import { Button, Dialog, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import { GridFilterPanel, useGridApiContext } from '@mui/x-data-grid-pro';

const CustomGridFilterPanel: React.FC = (): JSX.Element | null => {
  const context = useGridApiContext();
  if (!context) return null;

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  if (isSmall) {
    return (
      <Dialog maxWidth="xs" open={isSmall} onClose={context.current.hideFilterPanel}>
        <DialogContent sx={{ padding: 0, overflowX: 'auto', mt: theme.spacing(2) }}>
          <GridFilterPanel />
        </DialogContent>
        <DialogActions>
          <Button onClick={context.current.hideFilterPanel}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  return <GridFilterPanel />;
};

export default CustomGridFilterPanel;
